<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    {{ newCategory ? "Create" : "Update" }} Category
  </div>
  <div class="header-right">
    <button
      *ngIf="newCategory"
      mat-button
      color="lightGreen"
      (click)="createCategory()"
      [disabled]="saveDisabled"
    >
      Create Category
    </button>

    <button
      *ngIf="!newCategory"
      mat-button
      color="lightGreen"
      (click)="saveCategory()"
      [disabled]="saveDisabled"
    >
      Update Category
    </button>
  </div>
</div>
<div class="category">
  <div class="container">
    <div class="container-header no-bottom-border">
      <div class="text">Category</div>
    </div>
    <div class="container-content">
      <div class="row">
        <lhpe-input
          [formGroup]="categoryGroup"
          controlName="nameControl"
          placeholder="Name"
        >
        </lhpe-input>
      </div>

      <div class="row">
        <lhpe-input
          [formGroup]="categoryGroup"
          controlName="iconControl"
          placeholder="Icon"
          [matAutocomplete]="value"
        >
        </lhpe-input>

        <mat-autocomplete #value="matAutocomplete">
          <mat-option *ngFor="let icon of filteredIcons" [value]="icon.name">
            <span style="min-width: 30px"
              ><fa-icon [icon]="icon.icon"></fa-icon
            ></span>
            {{ icon.name }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="row">
        <lhpe-input
          [formGroup]="categoryGroup"
          controlName="colorControl"
          placeholder="Color"
        >
        </lhpe-input>

        <button
          class="color-picker-btn"
          mat-button
          [(colorPicker)]="colorPickerColor"
          cpOutputFormat="hex"
          [cpOKButton]="true"
          cpOKButtonText="Set Color"
          [cpCancelButton]="true"
          (colorPickerSelect)="onColorPickerOK()"
          cpCancelButtonClass="color-picker-option color-picker-cancel-btn"
          cpOKButtonClass="color-picker-option color-picker-add-btn"
        >
          <span><fa-icon [icon]="faPalette"></fa-icon></span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showPreview" class="preview">
    <div class="box" [ngStyle]="{ 'background-color': colorControl.value }">
      <span><fa-icon [icon]="currentIcon!"></fa-icon></span>
    </div>
  </div>
</div>
